import { render, staticRenderFns } from "./TestEnded.vue?vue&type=template&id=1aeea608&scoped=true&"
import script from "./TestEnded.vue?vue&type=script&lang=js&"
export * from "./TestEnded.vue?vue&type=script&lang=js&"
import style0 from "./TestEnded.vue?vue&type=style&index=0&id=1aeea608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeea608",
  null
  
)

export default component.exports